import '../css/index.scss';
import $ from 'jquery';
import { setupLenis } from '../scripts/lenis.js';
import ProgressBar from 'progressbar.js';

'use strict';

/* ======================================
  定数・ユーティリティ
====================================== */

const BREAKPOINT_SP = 768;

const isDesktop = () => window.innerWidth > BREAKPOINT_SP;

const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

/* ======================================
  Lenis / Height
====================================== */

let lenis = null;

function setupScrollEngine() {
  if (isDesktop()) {
    lenis = setupLenis();
    setupLenisResizeOnImageLoad();
  } else {
    const h = window.innerHeight;
    document.querySelectorAll('.setHeight')
      .forEach(el => el.style.height = `${h}px`);
  }
}

// html { height: 100% } により document.documentElement 自体の「箱としての
// サイズ」は常にビューポート高に固定されているため、Lenisの autoResize
// （ResizeObserverでdocument.documentElementを監視）は scrollHeight の伸びを
// 検知できない。loading="lazy" の画像が下の方で読み込まれてページの実際の
// 高さが増えても、Lenis内部のスクロール上限(limit)が追従せず、その手前で
// マウスホイールでのスクロールが効かなくなる。
// 画像の読み込み完了(loadイベント、bubbleしないためcaptureで拾う)のたびに
// lenis.safeResize()（lenis.js側）を呼び、上限を実際の高さに追従させる。
// resize()を直接呼ばず必ずsafeResize()経由にすることで、複数の画像が
// ほぼ同時に読み込まれて上限が段階的に伸びる場合でも、スクロール先が
// 古い上限に取り残されないようにする。
function setupLenisResizeOnImageLoad() {
  document.addEventListener('load', (e) => {
    if (e.target.tagName === 'IMG') {
      lenis?.safeResize();
    }
  }, true);
}

/* ======================================
  Navigation
====================================== */

function setupAnchorScroll() {
  document.querySelectorAll('.nav-item-link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const targetId = link.dataset.target;
      const target = document.getElementById(targetId);

      if (!target) return;

      // Desktop（Lenis）
      if (lenis) {
        lenis.scrollTo(target);
      }
      // Mobile / Tablet（Native）
      else {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

/* ======================================
  Loading
====================================== */

function setupLoading() {
  const bar = new ProgressBar.Line('#loading .progressBar', {
    strokeWidth: 1,
    easing: 'easeInOut',
    duration: 3000,
    color: 'rgba(255,255,255,.24)',
    trailColor: 'transparent',
    trailWidth: '100.0%',
    svgStyle: {width: '100.0%', height: '100.0%'},
    from: { color: 'rgba(255,255,255,.24)' },
    to: { color: 'rgba(255,255,255,1.0)' },
    step: (state, bar) => {
      // bar.setText(Math.round(bar.value() * 100) + ' %');
      bar.path.setAttribute('stroke',state.color);
    },
  });

  bar.animate(1, () => {
    $('#loading').fadeOut(300);
  });
}

function setupFadeIn() {
  const element = document.getElementById("loading");
  element.style.transition = "opacity .64s ease-in-out";
  element.style.opacity = "0";
  element.addEventListener("transitionend", () => {
    element.style.display = "none";
  }, { once: true });
}

/* ======================================
  Scroll Effects
====================================== */

function checkScroll() {
  const scrollY = window.scrollY;
  const vh = window.innerHeight;
  const threshold = vh * 0.4;

  // youuniverse
  const universe = document.getElementById('template-youniverse');
  universe?.classList.toggle('scrolled', scrollY > threshold);
}

function scrollAddClass() {
  const vh = window.innerHeight;
  document.querySelectorAll('.animate').forEach(el => {
    const pos = el.getBoundingClientRect().top + vh * 0.24;
    if (pos < vh) el.classList.add('is_animated');
  });
}

function onScroll() {
  checkScroll();
  scrollAddClass();
}

/* ======================================
  Text Lines
====================================== */

function setupTextLines() {
  document.querySelectorAll('.txtlines').forEach((el, index) => {
    if (!el.dataset.original) {
      el.dataset.original = el.textContent;
    }

    const lines = el.dataset.original.split('\n');
    const delay = 0.08;

    el.innerHTML = lines.map((line, i) => {
      const extra = index === 0 ? 0.65 : 0;
      return `<span class="line" style="transition-delay:${delay * (i + 1) + extra}s">${line}</span>`;
    }).join('');
  });
}

/* ======================================
  Drawer (jQuery)
====================================== */

function setupDrawer() {
  const $btn = $('.js-drawer-button');
  const $nav = $('.js-drawer-nav');
  const $link = $('.js-drawer-nav .nav-item-link');

  const toggle = () => {
    $btn.toggleClass('--active');
    $nav.toggleClass('--active');
  };

  $btn.on('click', toggle);
  $link.on('click', toggle);
}

/* ======================================
  Resize
====================================== */

let resizeTimer;

function onResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    setVh();
    setupTextLines();
    lenis?.resize();
  }, 200);
}

/* ======================================
  Init
====================================== */

document.addEventListener('DOMContentLoaded', () => {
  setupScrollEngine();
  setupAnchorScroll();
  setupTextLines();
  setupDrawer();
  onScroll();
});

window.addEventListener('load', () => {
  setVh();

  (() => {
    // スマホのみ
    if (window.matchMedia('(min-width: 768px)').matches) return;
    setupLoading();
  })();
  (() => {
    // PCのみ
    if (window.matchMedia('(max-width: 769px)').matches) return;
    setupFadeIn();
  })();
});

window.addEventListener('scroll', onScroll);
window.addEventListener('resize', onResize);


(() => {
  // スマホのみ
  if (window.matchMedia('(min-width: 768px)').matches) return;

  const lProduct = document.querySelector('.l-product');
  if (!lProduct) return;

  const products = Array.from(lProduct.children);

  products.forEach(product => {
    const secondBlock = product.querySelector('.second-block');
    const imgWrap = product.querySelector('.imgWrap');
    if (!secondBlock || !imgWrap) return;

    const pictureCount = imgWrap.querySelectorAll('picture').length;

    const LAST_HOLD_MULTIPLIER = 1.5;
    const extraVh = 100 * (LAST_HOLD_MULTIPLIER - 1);

    secondBlock.style.height =
      `${pictureCount * 120 + extraVh}vh`;
  });
})();

(() => {
  // スマホのみ
  if (window.matchMedia('(min-width: 768px)').matches) return;

  const products = document.querySelectorAll('.box-product');

  products.forEach(product => {
    const firstBlock  = product.querySelector('.first-block');
    const secondBlock = product.querySelector('.second-block');
    const imgWrap     = product.querySelector('.imgWrap');
    const wrapper     = imgWrap?.querySelector('div');
    const pictures    = wrapper
      ? Array.from(wrapper.querySelectorAll('picture'))
      : [];

    if (!firstBlock || !secondBlock || !imgWrap || !pictures.length) return;

    let currentIndex = -1;
    let fixedBaseScroll = null;
    let lastScrollY = window.scrollY;

    pictures.forEach(p => p.classList.remove('is-active'));
    imgWrap.classList.remove('is-fixed', 'is-visible');

    const setActive = index => {
      pictures.forEach((p, i) => {
        p.classList.toggle('is-active', i === index);
      });
    };

    const onScroll = () => {

      const vh = window.innerHeight;
      const scrollY = window.scrollY;
      const delta = scrollY - lastScrollY;
      const direction = delta > 0 ? 'down' : delta < 0 ? 'up' : null;

      const firstRect  = firstBlock.getBoundingClientRect();
      const secondRect = secondBlock.getBoundingClientRect();
      const productRect = product.getBoundingClientRect();

      const isInView =
        productRect.bottom > 0 &&
        productRect.top < vh;

      if (!isInView) {
        lastScrollY = scrollY;
        return;
      }

      const shouldFix = secondRect.top <= 0;
      const firstTenPercent = firstRect.top <= vh * 0.95;

      /* ===============================
        ① FIXED制御
      =============================== */

      if (shouldFix && fixedBaseScroll === null) {
        fixedBaseScroll = scrollY;

        // 下スクロールでfixedになった瞬間だけvisible
        if (direction === 'down') {
          imgWrap.classList.add('is-visible');
        }
      }

      if (shouldFix) {
        imgWrap.classList.add('is-fixed');
      }

      /* ===============================
        ② 下スクロール時 visible制御
      =============================== */

      if (direction === 'down') {

        // first-blockが5%入ったら消す
        if (firstTenPercent && firstRect.bottom > 0) {
          imgWrap.classList.remove('is-visible');
        }
      }

      /* ===============================
        ③ 上スクロール時 visible制御
      =============================== */

      if (direction === 'up') {

        // first-blockが5%未満になったら再表示
        if (!firstTenPercent && firstRect.bottom > 0) {
          imgWrap.classList.add('is-visible');
        }

        // fixed解除45%手前で消す
        if (secondRect.top > -vh * 0.45) {
          imgWrap.classList.remove('is-visible');
        }
      }

      /* ===============================
        ④ fixed解除
      =============================== */

      if (direction === 'up' && secondRect.top > 0) {
        imgWrap.classList.remove('is-fixed');
        fixedBaseScroll = null;
      }

      /* ===============================
        ⑤ 画像切替（fixed中）
      =============================== */

      if (fixedBaseScroll !== null && shouldFix) {

        const passed = scrollY - fixedBaseScroll;
        const vhStep = vh;
        const FIRST_HOLD = vh;
        const maxIndex = pictures.length - 1;

        const normalArea =
          FIRST_HOLD + vhStep * (maxIndex - 1);

        let index;

        if (passed < FIRST_HOLD) {
          index = 0;
        } else if (passed < normalArea) {
          index =
            Math.floor((passed - FIRST_HOLD) / vhStep) + 1;
        } else {
          index = maxIndex;
        }

        if (index !== currentIndex) {
          currentIndex = index;
          setActive(currentIndex);
        }
      }

      lastScrollY = scrollY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
